import Base from 'app/models/base';

export default Base.extend({
  nameAndCompany() {
    const name = this.get('name');
    const company = this.get('company');
    let result = '';

    if (name && company) {
      result = `${company} c/o ${name}`;
    } else if (name) {
      result = name;
    } else if (company) {
      result = company;
    }

    return result;
  },

  cityStateZip() {
    const city = this.get('city');
    const state = this.get('state');
    const zip = this.get('zip');
    return `${city}, ${state} ${zip}`;
  },
});




// WEBPACK FOOTER //
// ./app/models/address.js